import { useLocation, useNavigate } from "react-router-dom";

const KEY = "hbhs_consult_source";
export const DIRECT_SOURCE = "Scrolled to form directly (no button clicked)";

export const setConsultSource = (label) => sessionStorage.setItem(KEY, label);
export const getConsultSource = () => sessionStorage.getItem(KEY) || DIRECT_SOURCE;
export const clearConsultSource = () => sessionStorage.removeItem(KEY);

// Records the button clicked, then brings the visitor to the intake form (from any page).
export function useConsultNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (source, areaId) => {
    setConsultSource(source);
    const target = areaId ? `/?area=${areaId}#contact` : "/#contact";
    if (pathname === "/") {
      setTimeout(() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }), 200);
    }
    navigate(target);
  };
}
